(() => {
  const chatSelectors = [
    'inbox-online-store-chat#ShopifyChat',
    '#ShopifyChat',
    '#shopify-chat',
    '#dummy-chat-button-iframe',
    'iframe#ShopifyChat'
  ];

  function setChatHidden(hidden) {
    chatSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (hidden) {
          el.dataset.jeieamMenuHidden = 'true';
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
        } else if (el.dataset.jeieamMenuHidden === 'true') {
          el.style.removeProperty('display');
          el.style.removeProperty('visibility');
          el.style.removeProperty('pointer-events');
          delete el.dataset.jeieamMenuHidden;
        }
      });
    });
  }

  function syncMenuState() {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    const isOpen = Boolean(drawer && drawer.hasAttribute('open'));
    setChatHidden(isOpen);
  }

  function init() {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (drawer) {
      drawer.addEventListener('toggle', syncMenuState);
    }

    const observer = new MutationObserver(syncMenuState);
    observer.observe(document.body, { childList: true, subtree: true });

    syncMenuState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
